import { render, staticRenderFns } from "./approveReject.vue?vue&type=template&id=6a411580&"
import script from "./approveReject.vue?vue&type=script&lang=js&"
export * from "./approveReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports